'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidChat = function IoAndroidChat(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.4 5c0.3 0 0.5 0.3 0.5 0.6v16.7c0 0.4-0.2 0.7-0.5 0.7h-14.6l-7.1 7v-7h-4.4c-0.3 0-0.8-0.3-0.8-0.7v-16.7c0-0.3 0.5-0.6 0.8-0.6h26.1z m5 4.9c0.3 0 0.6 0.4 0.6 0.7v16.7c0 0.4-0.3 0.7-0.6 0.7h-4.5v7l-7-7h-10.2l3.1-3h14.1c1.4 0 2-0.8 2-2v-13.1h2.5z' })
        )
    );
};

exports.default = IoAndroidChat;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-chat.js
// module id = 2067
// module chunks = 0